<script lang="ts">
  import type { ContainerProps } from './container.types'

  let { children, class: classNative }: ContainerProps = $props()
</script>

<div class={`row-container ${classNative || ''}`}>
  {@render children()}
</div>
